import { __assign, __extends } from "tslib";
import React, { Component } from "react";
import { PnmacSectionListView, PnmacPageBubble, PnmacRowHeader, PnmacRowItem, PnmacCard, PnmacMediaQuery, PnmacMeta, PnmacLinearProgress, PnmacHtmlToNative, PnmacText, PnmacMediaContainer } from 'pnmac-universal-components';
import { connect } from "react-redux";
import * as Actions from "../redux/actions/actions.js";
import { bindActionCreators } from "redux";
import styles from '../styles/styles.js';
import { View, Image, Dimensions, Platform } from 'react-native';
import { textStyle } from '../v2/theme';
import withPnmacTitle from '../withPnmacTitle';
function removeFirstAndLastQuotes(str) {
  var firstChar = str.charAt(0);
  var lastChar = str[str.length - 1];
  //double quotes
  if (firstChar && lastChar === String.fromCharCode(34)) {
    str = str.slice(1, -1);
  }
  //single quotes
  if (firstChar && lastChar === String.fromCharCode(39)) {
    str = str.slice(1, -1);
  }
  return str;
}
var Expander = /** @class */function (_super) {
  __extends(Expander, _super);
  function Expander(props) {
    var _this = _super.call(this, props) || this;
    _this.expRef = /*#__PURE__*/React.createRef();
    return _this;
  }
  Expander.prototype.render = function () {
    var _this = this;
    var _a = this.props,
      data = _a.data,
      layout = _a.layout;
    var DATAEXPANDABLE = [{
      title: data.label,
      data: [{
        label: data.label,
        header: data.label,
        value: data.value
      }]
    }];
    var child;
    var object;
    if (/^[\],:{}\s]*$/.test(data.value.replace(/\\["\\\/bfnrtu]/g, '@').replace(/"[^"\\\n\r\t]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, ']').replace(/(?:^|:|,)(?:\s*\[)+/g, ''))) {
      if (data && typeof JSON.parse(data.value) == "object") {
        object = true;
        child = JSON.parse(data.value).map(function (s, i) {
          console.log("data.value", s);
          return /*#__PURE__*/React.createElement(Expander, {
            layout: layout,
            key: i,
            data: {
              label: s.title,
              value: s.content
            }
          });
        });
      }
    }
    return /*#__PURE__*/React.createElement(PnmacSectionListView, {
      noShadow: true,
      ref: this.expRef,
      data: DATAEXPANDABLE,
      collapsableSections: true,
      renderItem: function (_a, collapsed) {
        var item = _a.item;
        if (collapsed.some(function (s) {
          return s == item.header;
        })) {
          return /*#__PURE__*/React.createElement(PnmacRowItem, {
            rowContainerStyles: Platform.select({
              web: {
                marginTop: 0,
                paddingBottom: 20,
                paddingLeft: 20,
                paddingRight: 20,
                marginHorizontal: 15
              },
              default: {
                marginTop: 0,
                paddingBottom: 20,
                paddingLeft: 20,
                paddingRight: 20
              }
            }),
            renderChildren: function () {
              return object ? child : /*#__PURE__*/React.createElement(PnmacHtmlToNative, __assign({}, _this.props, {
                value: removeFirstAndLastQuotes(item.value)
              }));
            }
          });
        } else {
          return null;
        }
      },
      renderSectionHeader: function (_a) {
        var _b, _c, _d, _e, _f;
        var index = _a.index,
          title = _a.section.title;
        var open = ((_c = (_b = _this.expRef) === null || _b === void 0 ? void 0 : _b.current) === null || _c === void 0 ? void 0 : _c.state.collapsed.indexOf(title)) > -1;
        return /*#__PURE__*/React.createElement(PnmacRowHeader, {
          rowHeaderStyles: __assign(__assign({}, styles.selectionListView.rowHeaderStyles), {
            fontWeight: "normal"
          }),
          rowHeaderContainerStyles: layout.mobile ? {
            borderBottomWidth: open ? 1 : 0,
            borderBottomColor: "#EFEFEF",
            borderBottomLeftRadius: open ? 0 : 10,
            borderBottomRightRadius: open ? 0 : 10,
            marginBottom: 0,
            marginTop: 0
          } : __assign(__assign({}, styles.selectionListView.rowHeaderContainerStyles), {
            marginBottom: 0,
            marginTop: 0,
            marginLeft: 10,
            paddingLeft: 25
          }),
          onClickExpand: function () {
            return _this.expRef.current.collapseItem(title);
          },
          item: /*#__PURE__*/React.createElement(PnmacText, {
            style: textStyle.defaultTextTitle
          }, title),
          isExpand: ((_f = (_e = (_d = _this.expRef) === null || _d === void 0 ? void 0 : _d.current) === null || _e === void 0 ? void 0 : _e.state) === null || _f === void 0 ? void 0 : _f.collapsed.indexOf(title)) > -1
        });
      }
    });
  };
  return Expander;
}(React.PureComponent);
var FAQ = /** @class */function (_super) {
  __extends(FAQ, _super);
  function FAQ(props) {
    var _this = _super.call(this, props) || this;
    _this.expRef = /*#__PURE__*/React.createRef();
    return _this;
  }
  FAQ.prototype.render = function () {
    var _this = this;
    var _a = this.props,
      translations = _a.translations,
      layout = _a.layout;
    var isPennymac = layout.isPennymac,
      isCobranded = layout.isCobranded,
      isPrivateLabel = layout.isPrivateLabel;
    var faqs = (layout === null || layout === void 0 ? void 0 : layout.faqs) || [];
    var DATAEXPANDABLE = [];
    faqs.map(function (s) {
      var title, data, rawData;
      if (layout.language === "en") {
        title = s.englishTitle;
        rawData = s.englishContent;
      } else {
        title = s.spanishTitle;
        rawData = s.spanishContent;
      }
      data = rawData.filter(function (row) {
        if (isPennymac) {
          return !row.title.includes('<<FOR COBRANDED>>') && !row.title.includes('<<FOR PRIVATE LABEL>>');
        } else if (isCobranded) {
          return !row.title.includes('<<FOR PENNYMAC>>') && !row.title.includes('<<FOR PRIVATE LABEL>>');
        } else if (isPrivateLabel) {
          return !row.title.includes('<<FOR PENNYMAC>>') && !row.title.includes('<<FOR COBRANDED>>');
        }
        return true;
      });
      var removeCustomKey = data.filter(function (row) {
        return row.title.includes('<<FOR COBRANDED>>') || row.title.includes('<<FOR PRIVATE LABEL>>') || row.title.includes('<<FOR PENNYMAC>>');
      }).map(function (e) {
        return e.title.replace('<<FOR COBRANDED>> ', '').replace('<<FOR PRIVATE LABEL>>  ', '').replace('<<FOR PENNYMAC>> ', '');
      });
      data = data.filter(function (row) {
        return !removeCustomKey.some(function (key) {
          return row.title === key;
        });
      }).map(function (e) {
        var label = e.title.replace('<<FOR COBRANDED>> ', '').replace('<<FOR PRIVATE LABEL>>  ', '').replace('<<FOR PENNYMAC>> ', '');
        return {
          label: label,
          header: title,
          value: e.content
        };
      });
      if (data.length > 0) {
        DATAEXPANDABLE.push({
          title: title,
          data: data
        });
      }
    });
    return /*#__PURE__*/React.createElement(PnmacMediaQuery, {
      queries: {
        small: "(max-width: 599px)",
        medium: "(min-width: 600px) and (max-width: 1199px)",
        large: "(min-width: 1200px)"
      }
    }, function (matches) {
      return /*#__PURE__*/React.createElement(View, {
        style: {
          paddingHorizontal: 10,
          paddingBottom: 10,
          marginTop: -10
        },
        id: "main-content"
      }, /*#__PURE__*/React.createElement(PnmacMeta, {
        title: translations.faq
      }), (DATAEXPANDABLE === null || DATAEXPANDABLE === void 0 ? void 0 : DATAEXPANDABLE.length) > 0 ? /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(PnmacSectionListView, {
        ref: _this.expRef,
        data: DATAEXPANDABLE,
        collapsableSections: true,
        renderItem: function (_a, collapsed) {
          var _b, _c;
          var index = _a.index,
            item = _a.item;
          var notLastElement = index <= ((_c = (_b = DATAEXPANDABLE.find(function (header) {
            return header.title == item.header;
          })) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.length) - 2;
          if (collapsed.some(function (s) {
            return s == item.header;
          })) {
            return /*#__PURE__*/React.createElement(View, {
              style: layout.mobile ? {
                backgroundColor: "#FFF",
                borderBottomLeftRadius: notLastElement ? 0 : 10,
                borderBottomRightRadius: notLastElement ? 0 : 10
              } : {
                backgroundColor: "#FFF",
                borderBottomLeftRadius: notLastElement ? 0 : 10,
                borderBottomRightRadius: notLastElement ? 0 : 10
              }
            }, /*#__PURE__*/React.createElement(Expander, {
              layout: layout,
              data: item,
              lastItem: notLastElement
            }));
          } else {
            return null;
          }
        },
        renderSectionHeader: function (_a) {
          var _b, _c, _d, _e;
          var title = _a.section.title;
          var open = ((_c = (_b = _this.expRef) === null || _b === void 0 ? void 0 : _b.current) === null || _c === void 0 ? void 0 : _c.state.collapsed.indexOf(title)) > -1;
          return /*#__PURE__*/React.createElement(PnmacRowHeader, {
            rowHeaderStyles: styles.selectionListView.rowHeaderStyles,
            rowHeaderContainerStyles: layout.mobile ? {
              marginBottom: open ? 0 : 10,
              borderBottomWidth: open ? 1 : 0,
              borderBottomColor: "#EFEFEF",
              borderBottomLeftRadius: open ? 0 : 10,
              borderBottomRightRadius: open ? 0 : 10
            } : __assign(__assign({}, styles.rowHeaderContainerStyles), {
              borderBottom: open ? "1px solid #e9e9e9" : "none",
              borderBottomLeftRadius: open ? 0 : 10,
              borderBottomRightRadius: open ? 0 : 10
            }),
            onClickExpand: function () {
              var _a;
              return (_a = _this.expRef) === null || _a === void 0 ? void 0 : _a.current.collapseItem(title);
            },
            item: /*#__PURE__*/React.createElement(PnmacText, {
              style: textStyle.formTitleSection
            }, title),
            isExpand: ((_e = (_d = _this.expRef) === null || _d === void 0 ? void 0 : _d.current) === null || _e === void 0 ? void 0 : _e.state.collapsed.indexOf(title)) > -1
          });
        }
      })) : /*#__PURE__*/React.createElement(PnmacLinearProgress, null));
    });
  };
  return FAQ;
}(Component);
var mapStateToProps = function (state) {
  return {
    layout: state,
    translations: state.translations
  };
};
var mapDispatchToProps = function (dispatch) {
  return __assign({
    dispatch: dispatch
  }, bindActionCreators(Actions, dispatch));
};
export default connect(mapStateToProps, mapDispatchToProps)(withPnmacTitle(FAQ, function (props) {
  return props.translations.faq;
}));